import { render, staticRenderFns } from "./ShoppinglistButton.vue?vue&type=template&id=88f3c416&"
import script from "./ShoppinglistButton.vue?vue&type=script&lang=js&"
export * from "./ShoppinglistButton.vue?vue&type=script&lang=js&"
import style0 from "./ShoppinglistButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports